// Map feature styling: a small dict of generic styles keyed by geometry
// type, plus a tiny registry so consumer-side code (e.g. amphis-observation
// styling) can register named stylers without polluting the generic
// components.
//
// Usage from a <map-vector-layer style-key="my-domain"> consumer:
//
//   import { registerFeatureStyle } from './map-styles.js';
//   registerFeatureStyle('my-domain', (feature) => myStyle(feature));
//
// <map-vector-layer> calls `styleResolver(key)` to fetch the styler;
// without a key (or unknown key) it returns a generic geometry-type-based
// resolver.

import {Fill, Stroke, Style, Circle} from 'ol/style.js';


export const mapStyle = {
  Point: new Style({
    image: new Circle({
      fill:   new Fill({color: 'rgba(255,255,0,0.4)'}),
      radius: 5,
      stroke: new Stroke({color: '#ff0', width: 1}),
    }),
  }),
  PointHover: new Style({
    image: new Circle({
      fill:   new Fill({color: 'rgba(255,255,100,0.9)'}),
      radius: 12,
      stroke: new Stroke({color: '#ff6', width: 2}),
    }),
  }),
  LineString: new Style({
    stroke: new Stroke({color: '#f00', width: 3}),
  }),
  MultiLineString: new Style({
    stroke: new Stroke({color: '#0f0', width: 3}),
  }),
  normal: new Style({
    fill:   new Fill({color: 'rgba(34, 34, 240, 0.1)'}),
    stroke: new Stroke({color: '#101071', width: 1}),
    image:  new Circle({
      radius: 7,
      fill:   new Fill({color: '#ffcc33'}),
    }),
  }),
  highlight: new Style({
    stroke: new Stroke({color: '#2222f0', width: 3}),
    fill:   new Fill({color: 'rgba(34, 34, 240, 0.2)'}),
  }),
};


// Generic styler: pick the style by geometry type, fall back to "normal".
export function genericFeatureStyle(feature) {
  return mapStyle[feature.getGeometry().getType()] || mapStyle.normal;
}


const registry = new Map();

export function registerFeatureStyle(key, fn) {
  registry.set(key, fn);
}

export function styleResolver(key) {
  if (key && registry.has(key)) return registry.get(key);
  return genericFeatureStyle;
}
